
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytournearchandrapur() {



  const cardData =
  {
    keyword: ' One Day Tour Near Chandrapur',
    heading:  'Woodland Escape: One Day Tour Near Chandrapur ',
    headingDescription: 'Woodland Escape Resort is an ideal destination for a one day tour near Chandrapur, offering a refreshing escape into lush greenery and tranquil surroundings. Just a short drive from the city, the resort invites visitors to spend the day enjoying nature walks, outdoor games, and peaceful picnic spots amidst a serene forest backdrop. Families and groups can relax under shady trees, indulge in delicious homely meals, and capture beautiful memories in the resort’s scenic lawns and gardens. With comfortable seating areas, courteous staff, and a soothing natural ambiance, Woodland Escape Resort near Chandrapur ensures every one-day outing becomes a perfect mix of relaxation, recreation, and rejuvenation away from the city’s hustle.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "One Day Tour Near Chandrapur",
      "description": "Discover the best one-day tours near Chandrapur offering a blend of natural beauty, cultural attractions, and peaceful escapes. These tours are perfect for travelers looking to explore scenic spots, historical sites, and local experiences within a short time. Whether you’re planning a quick family outing or a spontaneous solo trip, these destinations promise an unforgettable day filled with adventure and relaxation."
    },
    {
      "name": "Chandrapur Day Trip",
      "description": "Plan a refreshing day trip in Chandrapur and enjoy the city’s unique mix of heritage, nature, and modern comfort. Visit local attractions like temples, wildlife sanctuaries, and scenic lakes that showcase the charm of the region. With convenient routes, great food options, and friendly locals, a Chandrapur day trip is the perfect way to escape your routine and explore something new."
    },
    {
      "name": "Chandrapur Sightseeing Tour",
      "description": "Experience the cultural and natural wonders of Chandrapur with a one-day sightseeing tour. Explore popular destinations such as Tadoba Andhari Tiger Reserve, Mahakali Temple, and ancient forts that reveal the area’s rich history. Ideal for tourists and locals alike, these tours include comfortable travel, guided exploration, and stops at scenic viewpoints for memorable photos."
    },
    {
      "name": "Chandrapur Short Trip",
      "description": "Enjoy a quick and fulfilling short trip around Chandrapur with easy travel plans and exciting attractions. Perfect for couples, families, and groups, these short tours feature a mix of nature, culture, and recreation. Visit nearby villages, picnic spots, or eco-tourism areas to unwind and enjoy a peaceful break close to home."
    },
    {
      "name": "Affordable One Day Tour Chandrapur",
      "description": "Explore Chandrapur’s charm on a budget with affordable one-day tours that offer great value and unforgettable experiences. These pocket-friendly packages include local sightseeing, meals, and transport. Perfect for students, families, and travel enthusiasts, they combine adventure and comfort without stretching your wallet."
    },
    {
      "name": "Chandrapur Nearby Attractions Tour",
      "description": "Visit Chandrapur’s nearby attractions including temples, waterfalls, nature parks, and wildlife sanctuaries. Ideal for day-long adventures, this tour helps you explore hidden gems and scenic routes around the region. Enjoy a mix of nature and history while creating lasting memories of your trip to Chandrapur and its surroundings."
    },
    {
      "name": "Chandrapur Weekend Day Trip",
      "description": "Turn your weekend into a mini adventure with a relaxing day trip in and around Chandrapur. Spend quality time with family or friends exploring lakesides, gardens, or local attractions. These weekend tours are designed to help you recharge and experience the region’s peaceful environment, delicious local food, and natural charm."
    },
    {
      "name": "Chandrapur Family Day Trip",
      "description": "Create beautiful memories with your loved ones on a family day trip in Chandrapur. Enjoy kid-friendly attractions, open picnic areas, and cultural sites that everyone can enjoy. These family trips include safe travel options, engaging activities, and relaxing spots, making them perfect for bonding and fun-filled outdoor experiences."
    },
    {
      "name": "Chandrapur Nature Day Tour",
      "description": "Reconnect with nature through a one-day tour around Chandrapur’s serene landscapes, dense forests, and calm rivers. Ideal for nature lovers, photographers, and adventurers, these tours offer activities like bird watching, hiking, and exploring eco-friendly spots. Escape the city rush and spend your day surrounded by greenery and tranquility."
    },
    {
      "name": "Chandrapur City Day Tour",
      "description": "Explore the heritage and modern attractions of Chandrapur city with a full-day tour covering famous landmarks, temples, markets, and local eateries. Discover the region’s history and culture while enjoying the vibrant city life. Perfect for tourists and locals who wish to experience the best of Chandrapur in a single day."
    },
    {
      "name": "Chandrapur Riverside Day Tour",
      "description": "Relax by the riverside on a peaceful day tour in Chandrapur featuring scenic water views, picnic spots, and boating activities. Perfect for couples and families, this tour combines serenity with recreation. Enjoy the cool breeze, listen to the flowing water, and spend a rejuvenating day close to nature."
    },
    {
      "name": "Chandrapur Hill Day Trip",
      "description": "Escape to the hills near Chandrapur for a refreshing one-day trip filled with stunning views, hiking trails, and peaceful surroundings. These hill destinations offer an ideal mix of adventure and relaxation, making them perfect for nature enthusiasts and photography lovers seeking a quick highland retreat."
    },
    {
      "name": "Chandrapur Day Excursion Packages",
      "description": "Choose from carefully designed day excursion packages in Chandrapur that include transport, meals, and guided sightseeing. Perfect for school groups, corporate outings, or families, these packages ensure a hassle-free and enjoyable experience. Explore Chandrapur’s best attractions with professional guides and comfortable travel arrangements."
    },
    {
      "name": "Chandrapur Tour Booking",
      "description": "Easily book your Chandrapur one-day tour online and customize your itinerary according to your preferences. Select from cultural, adventure, or family-focused tours and confirm your bookings instantly. With transparent pricing and reliable services, Chandrapur tour booking ensures a convenient and stress-free travel experience."
    },
    {
      "name": "Chandrapur One Day Outing",
      "description": "Plan an exciting one-day outing in Chandrapur featuring outdoor games, local sightseeing, and delicious meals. Whether with family, friends, or colleagues, enjoy a blend of fun, relaxation, and exploration. These outings are designed to give you the perfect escape from daily life while discovering the natural and cultural beauty of Chandrapur."
    }
  ],
  "tableData": [
    ["- One Day Tour Near Chandrapur", "- Chandrapur Day Trip"],
    ["- Chandrapur Sightseeing Tour", "- Chandrapur Short Trip"],
    ["- Affordable One Day Tour Chandrapur", "- Chandrapur Nearby Attractions Tour"],
    ["- Chandrapur Weekend Day Trip", "- Chandrapur Family Day Trip"],
    ["- Chandrapur Nature Day Tour", "- Chandrapur City Day Tour"],
    ["- Chandrapur Riverside Day Tour", "- Chandrapur Hill Day Trip"],
    ["- Chandrapur Day Excursion Packages", "- Chandrapur Tour Booking"],
    ["- Chandrapur One Day Outing", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect One Day Tour Near Chandrapur",
    "WhyChoosedescription": "Woodland Escape Resort is the ideal destination for a refreshing one-day tour near Chandrapur. Surrounded by nature and greenery, it offers a peaceful environment to relax, explore, and unwind without the need for an overnight stay."
  },
  {
    "WhyChooseheading": "Beautiful Natural Surroundings",
    "WhyChoosedescription": "Set amidst scenic landscapes and dense greenery, the resort provides a calm and rejuvenating setting. It’s perfect for nature lovers seeking a tranquil escape close to Chandrapur."
  },
  {
    "WhyChooseheading": "Exciting Activities for All Ages",
    "WhyChoosedescription": "Guests can enjoy a range of activities including cycling, nature walks, outdoor games, and pond-side relaxation. Whether you prefer adventure or leisure, there’s something for everyone to enjoy."
  },
  {
    "WhyChooseheading": "Day-Use Comfort and Facilities",
    "WhyChoosedescription": "Woodland Escape Resort offers well-maintained rest zones, shaded areas, and comfortable sit-outs designed for day visitors. You can relax, dine, and enjoy your day in total comfort."
  },
  {
    "WhyChooseheading": "Tasty Meals and Refreshments",
    "WhyChoosedescription": "Enjoy freshly prepared local dishes, snacks, and beverages during your one-day tour. The resort ensures a delightful culinary experience that complements your relaxing getaway."
  },
  {
    "WhyChooseheading": "Ideal for Families and Groups",
    "WhyChoosedescription": "Whether it’s a family outing, friends’ get-together, or group picnic, the resort provides a safe and enjoyable atmosphere for bonding, laughter, and memorable experiences."
  },
  {
    "WhyChooseheading": "Convenient Location Near Chandrapur",
    "WhyChoosedescription": "Located just a short drive from Chandrapur, Woodland Escape Resort is easy to reach and perfect for spontaneous day trips. Spend more time in nature and less time traveling."
  }
]




















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one day tour near Chandrapur?",
    answer: "Woodland Escape Resort is the perfect destination for a refreshing one day tour near Chandrapur. Surrounded by lush greenery and peaceful surroundings, it offers relaxation, fun activities, and a break from the city’s hustle and bustle."
  },
  {
    question: "How far is Woodland Escape Resort from Chandrapur city?",
    answer: "The resort is conveniently located within driving distance from Chandrapur, making it ideal for a one day outing or weekend escape. It’s easy to reach and perfect for short getaways."
  },
  {
    question: "What can visitors do during a one day tour at Woodland Escape Resort?",
    answer: "Guests can enjoy open lawns, outdoor games, nature walks, cycling, and relaxation zones. The resort is designed to offer both fun and tranquility for families, friends, and couples."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups on a one day tour?",
    answer: "Absolutely! The resort is family-friendly and group-friendly, with safe and clean surroundings. Whether you’re planning a family day out or a group picnic, everyone will find something to enjoy."
  },
  {
    question: "Are meals and refreshments provided during the one day tour?",
    answer: "Yes, Woodland Escape Resort serves freshly prepared meals, snacks, and beverages. You can also choose one day tour packages that include lunch and refreshments for a complete experience."
  },
  {
    question: "How can we book a one day tour at Woodland Escape Resort near Chandrapur?",
    answer: "Booking is simple! You can call or send a WhatsApp message to our reservations team, or visit the official website. Advance booking is advised for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Saurabh & Family, Chandrapur",
    text: "Our one day tour at Woodland Escape Resort was amazing! The surroundings were peaceful, the food was great, and the kids had a wonderful time. Perfect place near Chandrapur for a day getaway."
  },
  {
    name: "Mrs. Pooja & Friends, Chandrapur",
    text: "We had such a relaxing and fun one day tour at Woodland Escape Resort! The greenery, fresh air, and open spaces made it the best short trip from Chandrapur. Highly recommended!"
  }
];





















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Tour Near Chandrapur",
  "image": "https://woodlandescape.com/assets/images/one-day-tour-chandrapur.jpg",
  "description": "Experience a perfect one day tour near Chandrapur at Woodlandescape Resort. Enjoy sightseeing, nature excursions, riverside views, and family-friendly activities for a memorable day trip.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "145"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-tour-chandrapur"
  }
};



  return (
    <div>

<Helmet>
  <title>One Day Tour Near Chandrapur | Scenic & Family-Friendly Day Trip | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a memorable one day tour near Chandrapur at Woodlandescape Resort. Enjoy sightseeing, nature excursions, riverside views, and family-friendly activities for the perfect day trip." 
  />
  <meta 
    name="keywords" 
    content="One Day Tour Near Chandrapur, Chandrapur Day Trip, Chandrapur Sightseeing Tour, Chandrapur Short Trip, Affordable One Day Tour Chandrapur, Chandrapur Nearby Attractions Tour, Chandrapur Weekend Day Trip, Chandrapur Family Day Trip, Chandrapur Nature Day Tour, Chandrapur City Day Tour, Chandrapur Riverside Day Tour, Chandrapur Hill Day Trip, Chandrapur Day Excursion Packages, Chandrapur Tour Booking, Chandrapur One Day Outing" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/25.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytournearchandrapur;